import Reveal from "./Reveal";
import ChapterHeader from "./ChapterHeader";

export default function Pricing({ t, waLink }) {
  const c = t.chapter04;
  return (
    <section id="pricing" className="pb-20 md:pb-28">
      <ChapterHeader
        num={c.num}
        overline={c.overline}
        title={c.title}
        subtitle={c.subtitle}
      />
      <div className="container-x mt-14 md:mt-16 grid grid-cols-12 gap-6">
        {c.pkgs.map((p, i) => {
          const featured = i === 1;
          return (
            <Reveal
              key={i}
              delay={i * 0.08}
              className="col-span-12 md:col-span-4"
              y={40}
            >
              <div
                className={`card-hover h-full rounded-3xl border ${
                  featured
                    ? "border-[var(--accent)] bg-[#0e0e0e]"
                    : "border-[var(--border)] bg-[var(--surface)]"
                } p-8 md:p-10 flex flex-col relative overflow-hidden`}
                data-testid={`pricing-card-${p.name.toLowerCase()}`}
              >
                {featured && (
                  <div className="absolute top-6 right-6 text-[10px] uppercase tracking-widest font-display bg-[var(--accent)] text-[var(--bg)] px-3 py-1 rounded-full">
                    {p.tag}
                  </div>
                )}
                {!featured && (
                  <div className="text-[10px] uppercase tracking-widest font-display text-[var(--text-muted)] mb-4">
                    {p.tag}
                  </div>
                )}
                <div className="font-display font-black text-4xl md:text-5xl uppercase tracking-tighter text-[var(--text)]">
                  {p.name}
                </div>
                <p className="mt-2 text-sm text-[var(--text-muted)] font-serif-italic">
                  {p.for}
                </p>

                <div className="mt-8 flex items-baseline gap-2">
                  <span className="text-[var(--text-muted)] font-display text-sm">
                    IDR
                  </span>
                  <span className="font-display font-black text-4xl md:text-5xl tracking-tighter text-[var(--text)]">
                    {p.price}
                  </span>
                </div>

                <ul className="mt-8 space-y-3 flex-1">
                  {p.items.map((it, k) => (
                    <li
                      key={k}
                      className="flex items-start gap-3 text-sm text-[var(--text-muted)]"
                    >
                      <span
                        className={`mt-1.5 w-1.5 h-1.5 rounded-full shrink-0 ${
                          featured
                            ? "bg-[var(--accent)]"
                            : "bg-[var(--text-muted)]"
                        }`}
                      />
                      <span className="leading-relaxed">{it}</span>
                    </li>
                  ))}
                </ul>

                <a
                  href={waLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`pricing-cta-${p.name.toLowerCase()}`}
                  className={`mt-10 inline-flex items-center justify-between gap-3 px-6 py-4 rounded-full font-display uppercase tracking-widest text-xs transition-all ${
                    featured
                      ? "bg-[var(--accent)] text-[var(--bg)] hover:bg-[var(--text)]"
                      : "border border-[var(--border)] text-[var(--text)] hover:border-[var(--accent)] hover:text-[var(--accent)]"
                  }`}
                >
                  {c.ctaPkg}
                  <span aria-hidden>→</span>
                </a>
              </div>
            </Reveal>
          );
        })}
      </div>
    </section>
  );
}
